export enum DocumentDistributionDestinationModule {
  eTMF = 2,
  SSU = 4,
}
